import * as React from "react";
import { useState } from "react";
import { client } from "sanity/client";

export enum SchemaType {
	Article = "post",
	TimelineEntry = "timelineEntry",
	Music = "music",
	Credits = "credits",
} 

/**
 * Fetch news articles from Sanity
 * @param amount The number of articles to fetch. Defaults to 10.
 * @returns Promise resolving to an array of Sanity posts
 */
export async function fetchArticles(type: SchemaType, amount: number = 10, lastEntryDate?: string, lastEntryId?: string){
	let query = "";
	switch (type){
		case SchemaType.TimelineEntry:
			query = lastEntryDate ? 
			`*[_type == "timelineEntry" && (
			date < "${lastEntryDate}"
			|| (date == "${lastEntryDate}" && _id > "${lastEntryId}")
			)] | order(date desc) [0...${amount}]` :
			`*[_type == "timelineEntry"] | order(date desc) [0...${amount}]`;
			break;
		case SchemaType.Music:
			query = `*[_type == "music"] | order(releaseDate desc)`;
			break;
		case SchemaType.Credits:
			query = `*[_type == "credits"] | order(releaseDate desc)`;
			break;
	}
	try {
		return await client.fetch(query);
	} catch (error) {
		console.error("Error fetching posts:", error);
	}
}

/**
 * Fetch credits from Sanity
 * @param amount The number of articles to fetch. Defaults to 10.
 * @returns Promise resolving to an array of Sanity posts
 */
export async function fetchSanityCredits(){
	const EXP_QUERY = `{
	...,
	type->,
	creditees[]{
		...,
		creditee->{
		...,
		tags[]-> 
		}
	}
	}`;
	let query = `*[_type == "credits"]{
	...,
	category_1${EXP_QUERY},
	category_2${EXP_QUERY},
	category_3${EXP_QUERY},
	category_4${EXP_QUERY},
	category_5${EXP_QUERY},
	category_6${EXP_QUERY},
	category_7${EXP_QUERY},
	category_8${EXP_QUERY}
	}
 	| order(releaseDate desc)`;
	try {
		return await client.fetch(query);
	} catch (error) {
		console.error("Error fetching posts:", error);
	}
}

export async function fetchArticleFromSlug(type: SchemaType, slug: string){
	const query = `*[_type == "${type}" && slug.current == "${slug}"]`;
	try {
		return await client.fetch(query);
	} catch (error) {
		console.error("Error fetching posts:", error);
	}
}

export async function getArticleCount(type: SchemaType){
	const query = `count(*[_type == "${type}"])`;
	try {
		return await client.fetch(query);
	} catch (error) {
		console.error("Error fetching posts:", error);
	}
}